// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__kHd2V"};